export const SITE = {
  name: "Arivu Finserve",
  tagline: "Clarity in every rupee. Confidence in every decision.",
  logo: "https://customer-assets-v7afamib.emergentagent.net/job_a300a556-afba-4274-b292-d21892bcea35/artifacts/f2ixxb28_logo%20ar.jpeg",
  advisor: "Avishaa Thakar",
  experience: "8",
  linkedin: "https://www.linkedin.com/in/avishaa-thakar-b1979b97/",
  calendly: "https://calendly.com/arivufinserve/30min",
  midasx: "https://arivufinserve.midasx.in/market-place/discovery",
  email: "arivufinserve@gmail.com",
  phone: "+91 98679 77887",
  whatsapp: "919867977887",
  whatsappMsg: "Hi Avishaa, I'd like to know more about your financial planning services.",
  location: "Mumbai, India",
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1479292889369-1a48f234247e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBhcmNoaXRlY3R1cmUlMjBnbGFzcyUyMGZhY2FkZXxlbnwwfHx8fDE3ODU1ODA3MjV8MA&ixlib=rb-4.1.0&q=85",
  growth: "https://images.unsplash.com/photo-1593679916468-851527f3ee27?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwyfHxsdXNoJTIwZ3JlZW4lMjBsYW5kc2NhcGUlMjBhZXJpYWx8ZW58MHx8fHwxNzg1NTgwNzI1fDA&ixlib=rb-4.1.0&q=85",
  office: "https://images.unsplash.com/photo-1683921045461-b8dc5ad37740?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwyfHxwcmVtaXVtJTIwb2ZmaWNlJTIwZGVzayUyMG5vdGVib29rfGVufDB8fHx8MTc4NTU4MDcyNXww&ixlib=rb-4.1.0&q=85",
  texture: "https://images.unsplash.com/photo-1615917063840-0b7c196e29c1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwyfHxhYnN0cmFjdCUyMGJsdWUlMjBncmVlbiUyMHRleHR1cmV8ZW58MHx8fHwxNzg1NTgwNzI1fDA&ixlib=rb-4.1.0&q=85",
};

export const WHY = [
  { title: "Goals, not products", desc: "We start with your life and your goals — never with a product to sell. Advice that stays genuinely on your side." },
  { title: "One connected plan", desc: "Investments, retirement, tax-efficiency and protection woven into a single, coherent strategy." },
  { title: "Discipline through cycles", desc: "A structured, evidence-based approach that keeps you steady when markets get noisy." },
  { title: "Clarity at every step", desc: "Plain-language guidance and regular reviews, so you always know where you stand and why." },
];

export const TESTIMONIALS = [
  { name: "Darshan P.", role: "Retirement planning client", quote: "Avishaa explained complex financial concepts in a practical, easy-to-understand way. The session felt personalised and well-structured — I walked away feeling confident and reassured about the decisions ahead." },
  { name: "Swapnil A.", role: "Financial planning client", quote: "Extremely insightful and practical. I finally understood how to align my investments with my long-term goals. The advice was tailored, clear and actionable." },
  { name: "Gopesh K.", role: "Portfolio review client", quote: "A great listener who asked all the right questions. The real-time portfolio walkthrough gave me clarity on restructuring my investments effectively. Insightful and genuinely fruitful." },
];

export const SERVICES = [
  {
    id: "financial-planning",
    num: "01",
    title: "Financial Planning",
    short: "A living roadmap for your money.",
    desc: "A holistic plan that maps your income, expenses, goals and risk into one clear strategy — so every rupee has a purpose and every milestone has a path.",
    points: ["Goal-based cash-flow mapping", "Emergency & protection planning", "Tax-efficient structuring", "Annual review & rebalancing"],
  },
  {
    id: "retirement-planning",
    num: "02",
    title: "Retirement Planning",
    short: "Design the freedom you've earned.",
    desc: "Build a corpus that outlives inflation and keeps your lifestyle intact. We model your retirement number and the disciplined path to reach it — with dignity, not guesswork.",
    points: ["Retirement corpus modelling", "Inflation-adjusted projections", "Pension & withdrawal strategy", "Legacy & estate alignment"],
  },
  {
    id: "investment-planning",
    num: "03",
    title: "Investment Planning",
    short: "Portfolios built on evidence, not noise.",
    desc: "A diversified, risk-aligned portfolio designed around your goals and time horizon — reviewed regularly so your investments stay disciplined through every market cycle.",
    points: ["Risk-profiled asset allocation", "Mutual fund & equity selection", "Goal-linked SIP strategy", "Ongoing portfolio monitoring"],
  },
];
